export default "__VITE_PUBLIC_ASSET__92384a25__"